import React, { useContext, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import AssignmentRules from "../../components/configurations/AssignmentRules";
import { CompletionRules } from "../../components/configurations/CompletionRules";
import CustomVariable from "../../components/configurations/CustomVariable";
import AppContext from "../../context/AppContext";
import translations from "../../components/common/Translations";
import AssignmentTable from "../../components/configurations/AssignmentRule/AssignmentTable";
import ActivitySelect from "../../components/common/task/ActivitySelect";
import { getActivityListByProjectId } from "../../service/User";
import ReactSelector from "../../components/common/CommonReactSelector";
import { components } from 'react-select';

const Placeholder = (props) => {
  return <components.Placeholder {...props} />;
};

const ConfigurationMain = () => {
  const [activeTab, setActiveTab] = useState("assignment");
  const { theme, langMode, setWorkflowName, workflowName, selectedOrgId , updateActivityId, projectId, activityLoader, activityId, setWorkflowId} =
    useContext(AppContext);
  const [activity, setActivity] = useState([]);
  const [selectedActivity,setSelectedActivity] = useState(0)

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };


  useEffect(() => {
    const fetchActivityList = async () => {

      try {
        const data = await getActivityListByProjectId(projectId);
        setActivity(data);
      } catch (error) {
        console.error("Error fetching departments:", error);
      }
    };

    fetchActivityList(); // Trigger the project fetch whenever `userInfo.organization` changes
  }, [projectId]);

  
    const handleChangeActivity = async(selectedValue) => {
        updateActivityId(selectedValue.value)
        setSelectedActivity(selectedValue)
    }


  const option = useMemo(() => {
    return (activity || [])
      .filter(Boolean)
      .map((item) => ({
        value: item.workflowId,
        label: item.workflowName,
      }));
  }, [activity]);

  const defaultActivityValue = useMemo(() => {
    if (projectId !== null && activityId && activity?.length) {
      const activityIdList = typeof activityId === 'string'
        ? activityId.split(',')
        : Array.isArray(activityId)
          ? activityId.map(id => id.toString())
          : [activityId?.toString()];

      return (activity || [])
        .filter((org) => activityIdList.includes(org.workflowId?.toString()))
        .map((dept) => ({
          value: dept.workflowId,
          label: dept.workflowName,
        }));
    }
    return [];
  }, [projectId, activityId, activity]);

  const dynamicHeight = useMemo(() => {
    const count = Array.isArray(selectedActivity) ? selectedActivity.length : 0;
    return count > 0 ? count * 27 + 'px' : '32px';
  }, [selectedActivity]);

  useEffect(() => {
    if (defaultActivityValue && defaultActivityValue.length > 0) {
      const valueString = defaultActivityValue.map(item => item.value).join(',');
      setWorkflowId(valueString);
      updateActivityId(valueString);
      localStorage.setItem("activityId", valueString);

      // Add this:
      setSelectedActivity(defaultActivityValue[0]); // if it's single-select
    }
  }, [defaultActivityValue]);

  return (
    <div
      className={`${
        theme === "dark"
          ? "dark-mode  "
          : theme === "high-contrast"
          ? "high-contrast  "
          : ""
      } flex flex-col w-full xl:p-7 lg:p-7 md:p-7 sm:p-7 p-2`}
    >
      <div className="flex flex-col w-full xl:gap-[29px] lg:gap-[29px] md:gap-[20px]">
        <div className="flex xl:flex-row flex-col xl:gap-2 gap-y-6 justify-between px-[10px]">
          <div className="flex xsm:flex-row flex-col gap-2 md:flex-nowrap sm:flex-nowrap items-center xl:justify-center justify-between">
            <h4

              className={`uppercase ml-[10px] font-semibold whitespace-nowrap text-gray-800 ${

                theme === "dark"
                  ? "dark-mode  "
                  : theme === "high-contrast"
                  ? "high-contrast  "
                  : ""
              }`}
            >
              {translations[langMode].assignment}
            </h4>
            <div className="w-[219px] ml-2 mt-2">
              <div className="text-[#00000066]">
               {!activityLoader && <ReactSelector
                  options={projectId !== null ? option : []}
                  onChange={handleChangeActivity}
                  components={Placeholder}
                  placeholder={(projectId !== null || activityId) ? (option.length > 0 )?  translations[langMode].select : translations[langMode].noactivity  : translations[langMode].noactivity}
                  isClearable={false}
                  // isMulti
                  borderRadius={"24px"}
                  height={dynamicHeight}
                  value={selectedActivity}
                />}
              </div>
            </div>
          </div>
          <div className="flex xl:flex-row lg:flex-col md:flex-col flex-col xl:gap-[50px] lg:gap-[20px] md:gap-[20px] gap-[20px] xl:mx-0 lg:mx-4 md:mx-4 mx-4">
            <ul
              className={`flex flex-nowrap text-sm font-medium  overflow-x-auto ${
                theme === "dark"
                  ? "border-gray-600 text-white"
                  : theme === "high-contrast"
                  ? "high-contrast"
                  : "text-[#236DB4] border-gray-300"
              }`}
            >
              <li>
                <Link
                  to=""
                  className={`px-4 py-3 font-bold flex items-center gap-2 focus:ring-2 focus:ring-blue-700 transition-all border border-[#236DB4] border-r-[#00000033] text-[16px]  whitespace-nowrap ${
                    activeTab === "completion"
                      ? "bg-[#236DB4] text-white rounded-sm"
                      : "text-[#236DB4] "
                  }`}
                  onClick={() => handleTabClick("completion")}
                >
                  {translations[langMode].complitionrule}
                </Link>
              </li>
              <li>
                <Link
                  to=""
                  className={`px-4 py-3 font-bold flex items-center gap-2 focus:ring-2 focus:ring-blue-700 transition-all border border-[#236DB4] border-x-[#00000033]  text-[16px] whitespace-nowrap ${
                    activeTab === "assignment"
                      ? "bg-[#236DB4] text-white rounded-sm"
                      : "text-[#236DB4]"
                  }`}
                  onClick={() => handleTabClick("assignment")}
                >
                  {translations[langMode].assignment}
                </Link>
              </li>
              <li>
                <Link
                  to=""
                  className={`px-4 py-3 font-bold flex items-center gap-2 focus:rounded-sm transition-all border border-[#236DB4] border-x-[#00000033] text-[16px] whitespace-nowrap ${
                    activeTab === "special-assignment"
                      ? "bg-[#236DB4] text-white rounded-sm"
                      : "text-[#236DB4]"
                  }`}
                  onClick={() => handleTabClick("special-assignment")}
                >
                  {translations[langMode].splaignrule}
                </Link>
              </li>
              <li>
                <Link
                  to=""
                  className={`px-4 py-3 font-bold flex items-center gap-2 focus:ring-2 focus:ring-blue-700 transition-all border border-[#236DB4] border-l-[#00000033] text-[16px] whitespace-nowrap ${
                    activeTab === "custom"
                      ? "bg-[#236DB4] text-white rounded-sm"
                      : "text-[-[#236DB4]"
                  }`}
                  onClick={() => handleTabClick("custom")}
                >
                  {translations[langMode].customerule}
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div
          className={`p-2 mt-1 xl:ms-4 ms-2 w-full ${
            theme === "dark"
              ? " border text-[white] border-gray-700"
              : theme === "high-contrast"
              ? "high-contrast"
              : " text-gray-700 "
          }`}
        >
          {activeTab === "completion" && <CompletionRules />}
          {activeTab === "assignment" && <AssignmentRules />}
          {activeTab === "special-assignment" && <AssignmentTable />}
          {activeTab === "custom" && <CustomVariable />}
        </div>
      </div>
    </div>
  );
};

export default ConfigurationMain;
